import { DevToolOptions } from '@/tokens/llm/LlmDevTools/types'

export type AskSopInputForm = {
  query: string
  userContext: string
  devToolOptions: DevToolOptions
}

export const ASK_SOP_INPUT_PROPS = {
  loading: {
    type: Boolean,
    required: true,
  },
  showDevTools: {
    type: Boolean,
    required: false,
    default: false,
  },
}
